import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem9,
} from '../../../business-components/Grid/Grid'

import { 
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    reiniciaConfiguracaoRelatorioReportList,
} from './EstudoServiceConfiguracaoRelatorio'



export const NaoExibirOpcaoAporteUnico = ({ values, handleChange }) => {

    return (
        <GridContainer>
            <GridItem9>
                <CheckboxPadrao
                    name="naoExibirOpcaoAporteUnico"
                    label={LABEL.naoExibirOpcaoAporteUnico}
                    checked={values.naoExibirOpcaoAporteUnico}
                    onChange={handleChange}
                />
            </GridItem9>
        </GridContainer>
    )
}
                            
export const UtilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira = ({ values, handleChange }) => {

    return (
        <GridContainer>
            <GridItem9>
                <CheckboxPadrao
                    name="utilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira"
                    label={LABEL.utilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira}
                    checked={values.utilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira}
                    onChange={handleChange}
                />
            </GridItem9>
        </GridContainer>
    )
}

export const ExibirCapitalSeguradoCarteiraInvestimentos = ({ values, handleChange }) => {

    return (
        <CheckboxPadrao
            name="exibirCapitalSeguradoCarteiraInvestimentos"
            label={LABEL.exibirCapitalSeguradoCarteiraInvestimentos}
            checked={values.exibirCapitalSeguradoCarteiraInvestimentos}
            onChange={handleChange}
        />
    )
}

export const IncluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia = ({ values, handleChange }) => {

    return (
        <CheckboxPadrao
            name="incluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia"
            label={LABEL.incluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia}
            checked={values.incluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia}
            onChange={handleChange}
        />
    )
}

export const UtilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia = ({ values, handleChange }) => {

    return (
        <CheckboxPadrao
            name="utilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia"
            label={LABEL.utilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia}
            checked={values.utilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia}
            onChange={handleChange}
        />
    )
}



export const Template = ({ values, handleChange, templateList, linhaTipoLicenca, jsonPagina }) => {

    return (
        <TextFieldNumberSelect
            name={"template"}
            label={LABEL.template}
            value={values.template || ''}
            onChange={(e) => {
                values.template = e.target.value
                reiniciaConfiguracaoRelatorioReportList(values, templateList, linhaTipoLicenca, jsonPagina)

                handleChange(e)
            }}
            list={templateList}
        />
    )
}